import AssessmentHeadIcon from "../../../../assets/icons/AssessmentHead.svg";



const assessments = [
  {
    id: 1,
    title: "Fundamentals of IT",
  },
  {
    id: 2,
    title: "Advance Cyber Security Principle (Basic and Advanced)",
  },
  {
    id: 3,
    title: "Module 02 - Introduction to Cybersecurity",
  },
  {
    id: 4,
    title: "Module 03 and 04 - Windows and Linux",
  },
  {
    id: 5,
    title: "Module 05 - Networking Fundamentals",
  },
  {
    id: 6,
    title: "Module 06 - Threats, Attacks, and Vulnerabilities",
  },
  {
    id: 7,
    title: "Module 07 - Risk Management and Security Policies",
  },
  {
    id: 8,
    title: "Module 08 - Incident Response and Digital Forensics",
  },
];
const QuizDemoCard = () => {


  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-6">
      {assessments.map((item) => (
        <div key={item.id} className="flex">
          <div
            className="
              flex flex-col h-full w-full
              rounded-xl p-5 shadow
              bg-white text-gray-900
              dark:bg-slate-900 dark:text-gray-100
            "
          >
            <div className="flex gap-3 mb-4">
              <img
                src={AssessmentHeadIcon}
                alt="Assessment"
                className="w-10 h-10"
              />
              <h6 className="font-medium leading-snug line-clamp-2">
                {item.title}
              </h6>
            </div>
     <div className="mt-3 mb-6 w-full h-[3px] rounded-full p-[0.5px]
  bg-gradient-to-r from-teal-500 to-blue-600
  dark:from-cyan-400 dark:to-indigo-500">

</div>
          
            <div className="mt-auto pt-5">
              <button

                className="
                  w-full px-5 py-2 rounded-full border
                  border-gray-900 dark:border-gray-200
                  text-base font-medium transition
                  hover:bg-[#0c313b] hover:text-white
                  dark:hover:bg-slate-300 dark:hover:text-black
                "
              >
                Open
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuizDemoCard;